import React from "react";
import { View, Image, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import Caret from "@assets/svg/Caret";

import t from "@constants/localization";

const PATH = "screens/PlaceOrderSuccess/OrderDetailsSection";

const showLimitedImages = (images = [], limit = 3) => {
  const totalImages = images.length;
  const displayImageArray =
    totalImages <= limit ? images : images.slice(0, limit);
  return (
    <View style={{ flexDirection: "row" }}>
      {displayImageArray.map((uri, idx) => (
        <Image
          source={{ uri }}
          resizeMode="contain"
          style={{
            width: 60,
            height: 60,
            borderWidth: 1,
            borderColor: "rgba(0, 0, 0, 0.1)",
            marginRight: 10,
          }}
        />
      ))}
      {totalImages > limit && (
        <View
          style={{
            width: 60,
            height: 60,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              color: "rgba(0, 0, 0, 0.56)",
              fontFamily: "NotoSansDevanagari-SemiBold",
            }}
          >
            +{totalImages - limit}
          </Text>
        </View>
      )}
    </View>
  );
};

const OrderDetailsSection = ({
  splitOrders = [],
  billingDetails = [],
  goToOrdersList = () => {},
}) => (
  <View>
    {splitOrders.map((so, index) => {
      return (
        <View
          style={{
            borderBottomWidth: 8,
            borderBottomColor: "rgba(0, 0, 0, 0.05)",
          }}
        >
          <View
            style={{
              flexDirection: "row",
              paddingVertical: 10,
              paddingLeft: 15,
              borderBottomWidth: 1,
              borderBottomColor: "rgba(0, 0, 0, 0.05)",
            }}
          >
            <Text
              style={{
                color: "rgba(0, 0, 0, 0.56)",
                fontFamily: "NotoSansDevanagari-Regular",
                fontSize: 14,
              }}
            >
              {t(`${PATH}/orderNo`)}|{"  "}
              <Text
                style={{
                  color: "rgba(0, 0, 0, 0.86)",
                  fontFamily: "NotoSansDevanagari-Bold",
                  fontSize: 14,
                }}
              >
                {so.order_id}
              </Text>
            </Text>
          </View>

          <View style={{ padding: 15 }}>
            {so.edd && (
              <Text
                style={{
                  color: "rgba(0, 0, 0, 0.56)",
                  fontFamily: "NotoSansDevanagari-Regular",
                  fontSize: 14,
                }}
              >
                {t(`${PATH}/deliveryDate`)}
                <Text
                  style={{
                    color: "rgba(0, 0, 0, 0.86)",
                    fontFamily: "NotoSansDevanagari-Bold",
                    fontSize: 14,
                  }}
                >
                  {so.edd}
                </Text>
              </Text>
            )}
            <Text
              style={{
                color: "rgba(0, 0, 0, 0.56)",
                fontFamily: "NotoSansDevanagari-Regular",
                fontSize: 14,
                marginTop: 6,
                marginBottom: 8,
              }}
            >
              {so.num_items} {t(`${PATH}/items`)} • {so.num_quantity}
              {t(`${PATH}/quantity`)}
            </Text>
            {showLimitedImages(so.item_photos, 4)}
          </View>
        </View>
      );
    })}
    <View
      style={{
        borderBottomWidth: 8,
        borderBottomColor: "rgba(0, 0, 0, 0.05)",
      }}
    >
      <View
        style={{
          paddingVertical: 12,
          paddingLeft: 15,
          borderBottomWidth: 1,
          borderBottomColor: "rgba(0, 0, 0, 0.1)",
        }}
      >
        <Text
          style={{
            color: "rgba(0, 0, 0, 0.86)",
            fontFamily: "NotoSansDevanagari-Bold",
            fontSize: 16,
          }}
        >
          {t(`${PATH}/priceDetails`)}
        </Text>
      </View>
      <View
        style={{
          paddingTop: 12,
          paddingHorizontal: 15,
          borderBottomWidth: 1,
          borderBottomColor: "rgba(0, 0, 0, 0.1)",
        }}
      >
        {billingDetails.map((detail, idx, arr) => (
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
              borderTopWidth: idx + 1 === arr.length ? 1 : 0,
              borderTopColor: "rgba(0, 0, 0, 0.1)",
              paddingTop: idx + 1 === arr.length ? 10 : 0,
            }}
          >
            <Text
              style={{
                color: "rgba(0, 0, 0, 0.86)",
                fontFamily: detail.bold
                  ? "NotoSansDevanagari-Bold"
                  : "NotoSansDevanagari-Regular",
                fontSize: 14,
              }}
            >
              {detail.text.trim()}
            </Text>
            <Text
              style={{
                color: detail.amountGreen ? "#27AE60" : "rgba(0, 0, 0, 0.86)",
                fontFamily:
                  detail.amountGreen || detail.bold
                    ? "NotoSansDevanagari-Bold"
                    : "NotoSansDevanagari-Regular",
                fontSize: 14,
              }}
            >
              {detail.value.trim()}
            </Text>
          </View>
        ))}
      </View>
      <TouchableOpacity
        onPress={goToOrdersList}
        style={{
          flexDirection: "row",
          paddingVertical: 12,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text
          style={{
            color: "#E40046",
            fontFamily: "NotoSansDevanagari-SemiBold",
            fontSize: 14,
            lineHeight: 20,
          }}
        >
          {t(`${PATH}/viewOrderDetails`)}
        </Text>
        <View style={{ marginBottom: 3 }}>
          <Caret strokeColor="#E40046" />
        </View>
      </TouchableOpacity>
    </View>
  </View>
);

export default OrderDetailsSection;
